exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.front[data-v-6c5bee9e]{\n    position: relative;\n    z-index: 99;\n}\n.v-btn--floating[data-v-6c5bee9e] {\n    position: relative;\n}\n", ""]);

// exports
